import { render, staticRenderFns } from "./BannerWork.vue?vue&type=template&id=4ace3d46&scoped=true"
import script from "./BannerWork.vue?vue&type=script&lang=js"
export * from "./BannerWork.vue?vue&type=script&lang=js"
import style0 from "./BannerWork.vue?vue&type=style&index=0&id=4ace3d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace3d46",
  null
  
)

export default component.exports